
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/streamers/[id]",
      function () {
        return require("private-next-pages/streamers/[id].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/streamers/[id]"])
      });
    }
  